import {
    useGetMemberTicketingMutation,
    useGetMemberArchivedTicketingMutation,
    useArchiveMemberTicketingMutation
} from '@services/member/member/member.endpoints';
import { TicketingTable } from '@services/member/ticketing/ticketing.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useMemo, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

export const useDetailsTicketsVM = () => {
    const { id } = useParams();

    const columnHelper = createColumnHelper<TicketingTable>();
    const [needReload, setNeedReload] = useState<boolean>();
    const [isArchived, setIsArchived] = useState<boolean>(false);
    const MySwal = withReactContent(Swal);
    const navigate = useNavigate();

    const [
        archiveMemberTicketing,
        {
            isLoading: isArchiveMemberTicketingLoading,
            isSuccess: isArchiveMemberTicketingSuccess
        }
    ] = useArchiveMemberTicketingMutation();


    useEffect(() => {
        if (isArchiveMemberTicketingSuccess) {
            setNeedReload((prev) => !prev);
        }
    }, [isArchiveMemberTicketingSuccess]);


    const handleArchiveTicketing = (lines: TicketingTable[], archive: boolean) => {
        if (!id) return;
        MySwal.fire({
            title: archive ? 'Êtes-vous sûr de vouloir archiver ces billets ?' : 'Êtes-vous sûr de vouloir désarchiver ces billets ?',
            icon: 'warning',
            showCancelButton: true,
            iconColor: '#01539D',
            confirmButtonColor: '#01539D',
            confirmButtonText: archive ? 'Archiver' : 'Désarchiver',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                lines.forEach((line) => {
                    archiveMemberTicketing({ id, ticketingId: line.id });
                });
            }
        });
    };

    const mutationHook = useMemo(() => {
        return isArchived ? useGetMemberArchivedTicketingMutation : useGetMemberTicketingMutation;
    }, [isArchived]);

    return {
        handleArchiveTicketing,
        navigate,
        columnHelper,
        isArchived,
        mutationHook,
        setIsArchived,
        isLoading: isArchiveMemberTicketingLoading,
        needReload,
        id
    };
};
